import styled from 'styled-components';


const StepperWrapper = styled.div`
.stepper {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(110, 159, 187, 0.2);
    height: 40px;
    border-radius: 20px;

    .step {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        height: 40px;
        width: 40px;
        border: 1px solid #6B47F5;
        background: #fff;
        color: #818b9b;
        border-radius: 50%;

        &.active {
            background: #34a853;
            color: #fff;
        }

        &.next {
            background: #6B47F5;
            color: #fff;
        }
    }

    &.titles {
        background: transparent;
    }

    .title {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        min-width: 50px;
        color: #818b9b;

        &.active {
            color: #34a853;
        }

        &.next {
            color: #6B47F5;
        }
    }
}

`;

export default StepperWrapper;